<script lang="ts">
  import { onMount } from 'svelte';
  import { _ } from 'svelte-i18n';
  import { push } from 'svelte-spa-router';
  import { getMatches, trackEvent } from '../lib/apiService';
  import ReportCard from '../components/ReportCard.svelte';
  import { settingsStore, refreshSettings } from '../stores/settings';
  import OnboardingModal from '../components/OnboardingModal.svelte';
  import { checkOnboardingStep } from '../lib/utils/onboardingUtils';

  let showOnboardingModal = false;
  let reports = [];
  
  async function loadReports() {
    try {
      await getMatches((result, status) => {
        if (status === 200) {
          reports = result;
        }
      });
    } catch (error) {
      console.error('Error loading reports:', error);
    }
  }

  // Check if user needs account settings onboarding
  async function checkAccountSettingsOnboarding() {
    try {
      const hasSeenOnboarding = await checkOnboardingStep('gameassist_home');
      if (!hasSeenOnboarding) {
        // Show welcome modal after a short delay for better UX
        setTimeout(() => {
          showOnboardingModal = true;
        }, 500);
      }
    } catch (error) {
      console.error('Error checking account settings onboarding:', error);
    }
  }

  // Close welcome modal
  function closeOnboardingModal() {
    showOnboardingModal = false;
  }
  
  function handleDelete(deletedId) {
    reports = reports.filter(report => report.id !== deletedId);
  }
  
  function handleNewMatch() {
    push('/new-match');
  }
  
  onMount(async () => {
    // Ensure settings are loaded before rendering the modal
    if (!$settingsStore.active_team.id) {
      await refreshSettings();
    }
    await loadReports();
    await checkAccountSettingsOnboarding();

});
</script>

<div class="home-page">

  <h4 class="text text-center my-4">
    {$_('home.title')}
  </h4>
  
  {#if  reports.length > 0}
    <div class="match-reports">
      <div class="reports-list">
        {#each reports as report (report.id)}
          <ReportCard {report} sessionInfo={$settingsStore} onDelete={handleDelete} />
        {/each}
      </div>
    </div>
  {:else}
    <div class="empty-state">
      <p>{$_('home.noMatches')}</p>
    </div>
  {/if}
  
</div>

<div class="sticky-footer">
    <div class="sticky-footer-buttons">
      <button 
        class="sticky-footer-btn full-width"
        on:click={handleNewMatch}
      >
        <ion-icon name="add-circle"></ion-icon>
        {$_('home.newMatch')}
      </button>
    </div>
</div>


<!-- Onboarding Modal -->
<OnboardingModal
  isOpen={showOnboardingModal}
  title={$_('onboarding.gameassist_home.title')}
  onClose={closeOnboardingModal}
>
  <p>{$_('onboarding.gameassist_home.step1')}</p>
  <p>{$_('onboarding.gameassist_home.step2')}</p>
</OnboardingModal>

<style>
  .home-page {
    padding-top: 1rem;
    padding-bottom: 1rem;
    max-width: 800px;
    margin: 0 auto;
  }
  
  .reports-list {
    margin-top: 1rem;
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }
  
  .empty-state {
    text-align: center;
    padding: 2rem;
  }
  
</style> 